import { render, staticRenderFns } from "./LoginChoose.vue?vue&type=template&id=7317f844&"
import script from "./LoginChoose.vue?vue&type=script&lang=js&"
export * from "./LoginChoose.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports